export const TIPOS_PROCESSO_LICENCIAMENTO = [
  {
    grupo: 'Licenças ambientais - Lei Federal nº 15.190/2025',
    opcoes: [
      ['LP', 'Licença Prévia (LP)'],
      ['LI', 'Licença de Instalação (LI)'],
      ['LO', 'Licença de Operação (LO)'],
      ['LAU', 'Licença Ambiental Única (LAU)'],
      ['LAC', 'Licença por Adesão e Compromisso (LAC)'],
      ['LOC', 'Licença de Operação Corretiva (LOC)'],
      ['LAE', 'Licença Ambiental Especial (LAE)'],
      ['LP/LI', 'Licença Prévia e de Instalação (LP/LI)'],
      ['LI/LO', 'Licença de Instalação e Operação (LI/LO)']
    ]
  },
  {
    grupo: 'Licenças e autorizações usuais no IMASUL',
    opcoes: [
      ['LIO', 'Licença de Instalação e Operação (LIO)'],
      ['AA', 'Autorização Ambiental (AA)'],
      ['AA - Supressão Vegetal', 'Autorização Ambiental - Supressão Vegetal'],
      ['CANI', 'Corte Isolado de Árvores Nativas (CANI)'],
      ['RLP', 'Renovação de Licença Prévia (RLP)'],
      ['RLI', 'Renovação de Licença de Instalação (RLI)'],
      ['RLO', 'Renovação de Licença de Operação (RLO)'],
      ['RAA', 'Renovação de Autorização Ambiental (RAA)']
    ]
  },
  {
    grupo: 'Outros',
    opcoes: [['outro', 'Outro']]
  }
];

export const TIPOS_PROCESSO_FLAT = TIPOS_PROCESSO_LICENCIAMENTO.flatMap(({ opcoes }) => opcoes);

export function TiposProcessoOptions() {
  return TIPOS_PROCESSO_LICENCIAMENTO.map(({ grupo, opcoes }) => (
    <optgroup key={grupo} label={grupo}>
      {opcoes.map(([value, label]) => <option key={value} value={value}>{label}</option>)}
    </optgroup>
  ));
}
